export default __webpack_public_path__ + "maps-guides-styles-expressions-zoom-high-1200-acc636f63125010f6a5e3722a07e0478.png";